import StoreX from '../../redux/oldStore';

/**
 * Stripe Connect OAuth result page (replaces Auth/StripeConnect.cshtml).
 * Auth/Stripe_Step04 completes token exchange server-side, then redirects here with query flags.
 */
const StripeConnectPage = () => {
  const successParam = (StoreX.GetQueryStringValue('success') || '').toLowerCase();
  const success = successParam === '1' || successParam === 'true';
  const error = StoreX.GetQueryStringValue('error') || 'An unknown error occurred.';

  return (
    <div className="main-body-page grow" data-testid="stripe-connect-page">
      <div style={{ padding: '40px 20px', maxWidth: 640 }}>
        {success ? (
          <div data-testid="stripe-connect-success">
            <h3>
              <i className="fal fa-check-circle text-success" /> Congratulations
            </h3>
            <p>
              We will now be able to accept payments for you. Your payments will be automatically
              deposited into your account; you can change these settings in your Stripe account.
            </p>
            <p>
              You are now done setting up payments; make sure you have checked the box to allow our
              system to collect payments for you.
            </p>
            <p>
              <a className="btn btn-primary" href="../" data-testid="stripe-connect-home">
                Go Home
              </a>
            </p>
          </div>
        ) : (
          <div data-testid="stripe-connect-error">
            <h3>
              <i className="fal fa-exclamation-triangle text-danger" /> Oops
            </h3>
            <strong>Something went wrong:</strong>
            <p data-testid="stripe-connect-error-message">{error}</p>
            <p>
              <a className="btn btn-default" href="../">
                Go Home
              </a>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default StripeConnectPage;
